var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgCorreo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 576 512",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M527.1 160c-3.834 0-7.555 1.305-10.55 3.701l-205.1 164c-13.31 10.66-33.69 10.66-47 0L48 154.6V128c0-26.51 21.49-48 48-48h312C412.4 80 416 76.42 416 72S412.4 64 408 64H96C60.65 64 32 92.65 32 128v256c0 35.35 28.65 64 64 64h384c35.35 0 64-28.65 64-64V176.9C544 167.6 536.4 160 527.1 160zM528 384c0 26.47-21.53 48-48 48H96c-26.47 0-48-21.53-48-48V175.1l206.5 165.2C264 347.8 275.9 352 288 352s24-4.184 33.5-11.76L528 175.1V384zM512 0c-35.35 0-64 28.65-64 64s28.65 64 64 64s64-28.65 64-64S547.3 0 512 0zM512 112c-26.47 0-48-21.53-48-48s21.53-48 48-48s48 21.53 48 48S538.5 112 512 112z"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCorreo);
export default __webpack_public_path__ + "static/media/correo.9e2abf6b.svg";
export { ForwardRef as ReactComponent };